<nz-card>

  <leap-product-tab-content-skeleton *ngIf="productVariantDeliverablesPending | async"></leap-product-tab-content-skeleton>
  <div *ngIf="!(productVariantDeliverablesPending | async)">
    <div *ngIf="!contentWrapper || !contentWrapper.length">
      No content available
    </div>
    <div *ngIf="contentWrapper && contentWrapper.length">
      <h4 class="title">Content</h4>
      <p class="description margin-top-6">The following contents are included with this product. For any questions about these contents, please, contact the Seller of this product.</p>

      <nz-collapse [nzBordered]="false">
        <nz-collapse-panel
                *ngFor="let panel of contentWrapper"
                [nzHeader]="panel.title + ' (' + panel.contentList.length + ')'"
                [nzActive]="panel.active"
                [nzExtra]="panelButtonRight"
                [nzShowArrow]="false">

          <ng-container *ngFor="let content of panel.contentList">
            <div class="separator"></div>
            <div class="content">
              <span>{{content.name}}</span>
              <a *ngIf="content.path" class="view-sample-link" target="_blank" rel="noopener noreferrer" href="{{content.path}}">View Sample</a>
            </div>
          </ng-container>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
  </div>

</nz-card>

<ng-template #panelButtonRight>
  <i nz-icon nzType="caret-down"></i>
</ng-template>


